// extracted by mini-css-extract-plugin
module.exports = {"database":"Database_database__2U3oX"};